import { Pipe, PipeTransform } from '@angular/core';
import { FilterType } from '../grid/utils/filter/filter.utils';
import { DescriptionFilterHandler } from '../helpers/filters/filter-handlers/description-filter-handler';
import { MonitorFilter } from '../state/monitor-filters/state';
import { CalendarFilter } from '../state/calendar-filter/state';

@Pipe({
  name: 'filterValue'
})
export class FilterValuePipe implements PipeTransform {
  transform(filter: CalendarFilter | MonitorFilter, args?: any): any {
    const { type, model } = filter;

    switch (type) {
      case FilterType.Radio:
      case FilterType.Dropdown:
        return model.value;
      case FilterType.Range:
      case FilterType.RadioRange:
      case FilterType.RangeInput:
      case FilterType.DateRange:
      case FilterType.NSet:
        return model.stringModel;
      case FilterType.Text:
        return model.filter;
      case FilterType.Set: {
        const set =
          model.value ||
          (model.values && model.values.length
            ? model.values
            : model.storeValues);
        if (!set || !set.length) {
          return filter.name === 'syndicate' && model.serviceOptionSelected
            ? 'Sole Managed'
            : 'None';
        }
        return model.isInclusive ||
          !Object.prototype.hasOwnProperty.call(model, 'isInclusive')
          ? `Including ${set.map(this.displayValue).join(', ')}`
          : `All Except ${model.storeValues.map(this.displayValue).join(', ')}`;
      }
      default:
        if (!type && DescriptionFilterHandler.isDoubleDescriptionModel(model)) {
          return DescriptionFilterHandler.getDoubleDescriptionLabel(model);
        }
        throw new Error(`Unknown filter type: ${type}`);
    }
  }

  displayValue(model) {
    return model.isBlank ? 'Blank' : model;
  }
}
